import {
    AbacoWebModule,
    MenuItem,
    RouterReadyEvent,
    VueRouter,
    ApplicationReadyEvent,
} from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";
import { createMenu } from "./menu";
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module/index";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import GlobalState from "@abaco/portal-global-state/src/modules/global-state/index";
import DashboardModule from "@abaco/dashboard-module/src/modules/dashboard";
import UserModule from "@abaco/user-module/src/modules/user-module";
import CropPlanModule from "@abaco/crop-plan-module/src/modules/crop-plan-module";
import ActivitiesModule from "@abaco/activities-module/src/modules/activities-module";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts";
import GrapesDashboardModule from "@abaco/grapes-dashboard-module/src/modules/grapes-dashboard-module";
import AlarmsModule from "@abaco/alarms-module/src/modules/alarms-module";
import OldWidgetsModule from "@abaco/widgets-container-module/src/modules/old-widgets";
import MeteoWidgetModule from "@abaco/widgets-container-module/src/modules/meteo-widgets/index";
import FarmMapModule from "@abaco/widgets-container-module/src/modules/farm-map-module";
import CostsRevenuesModule from "@abaco/costs-revenues-module/src/modules/costs-revenues-module";
import SatelitteWidgetModule from "@abaco/widgets-container-module/src/modules/satellites-widgets";
import R2UDashboardVuexModule from "./state";
import R2UApi from "./api/R2UApi";
import Vue from "vue";
import { HA_UNIT } from "@abaco/crop-plan-module/src/modules/crop-plan-module/api/utils";
import NumberUtils from "@abaco/web-components/src/components/input/NumberUtils";

const rootPath = "/sitiagri-rest-api/api_basic";
const state = new R2UDashboardVuexModule();

export const MODULE_ID = "r2u_dashboard_module";
export default class R2UDashboardModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private router!: VueRouter;

    private apiCreated = false;
    private rApi!: R2UApi;

    readonly vuexModule = state;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    menu: MenuItem[] = [];

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);

        Vue.filter("TO_AREA_HA", (val: number, fromFormat?: string) => {
            if (fromFormat === HA_UNIT) {
                return NumberUtils.stringify(val, 4);
            }
            return NumberUtils.stringify(val / 10000, 4);
        });
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const R2UApi = (await import("./api/R2UApi")).default;
        this.rApi = new R2UApi(http);
    }

    get r2uApi() {
        return this.rApi;
    }

    dependsOn = {
        [MapWebModule.MODULE_ID]: () => new MapWebModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [GlobalState.MODULE_ID]: () => new GlobalState(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [UserModule.MODULE_ID]: () => new UserModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
        [GrapesDashboardModule.MODULE_ID]: () => new GrapesDashboardModule(),
        [OldWidgetsModule.MODULE_ID]: () => new OldWidgetsModule(),
        [MeteoWidgetModule.MODULE_ID]: () => new MeteoWidgetModule(),
        [FarmMapModule.MODULE_ID]: () => new FarmMapModule(),
        [AlarmsModule.MODULE_ID]: () => new AlarmsModule(),
        [ActivitiesModule.MODULE_ID]: () => new ActivitiesModule(),
        [CostsRevenuesModule.MODULE_ID]: () => new CostsRevenuesModule(),
        [SatelitteWidgetModule.MODULE_ID]: () => new SatelitteWidgetModule(),
    };
}
